import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Users, Globe, Heart, Award, TrendingUp, MapPin } from "lucide-react";

export const SponsorImpact = () => {
  const impactStats = [
    {
      icon: <Users className="h-12 w-12 text-primary" />,
      title: "Children Reached",
      value: "10,000+",
      description: "Young minds inspired by our educational content"
    },
    {
      icon: <Globe className="h-12 w-12 text-secondary" />,
      title: "Global Families",
      value: "2,500+",
      description: "Families worldwide enjoying our cultural stories"
    },
    {
      icon: <Award className="h-12 w-12 text-accent" />,
      title: "Episodes Created",
      value: "15+",
      description: "High-quality educational episodes produced"
    },
    {
      icon: <MapPin className="h-12 w-12 text-primary" />,
      title: "Cultural Heritage",
      value: "100%",
      description: "Authentic Cayman Islands culture represented"
    },
    {
      icon: <TrendingUp className="h-12 w-12 text-secondary" />,
      title: "Annual Growth",
      value: "250%",
      description: "Year-over-year audience growth rate"
    },
    {
      icon: <Heart className="h-12 w-12 text-accent" />,
      title: "Community Impact",
      value: "Local",
      description: "Supporting Cayman Islands creative community"
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Our Impact So Far
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            See how Bobo & Teedee® is making a difference in children's education 
            and cultural preservation. Your sponsorship helps us expand this impact globally.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {impactStats.map((stat, index) => (
            <Card key={index} className="text-center hover:shadow-lg transition-all duration-300 hover:scale-105">
              <CardContent className="p-8">
                <div className="flex justify-center mb-4">
                  {stat.icon}
                </div>
                <h3 className="text-3xl font-bold text-primary mb-2">{stat.value}</h3>
                <h4 className="text-lg font-semibold mb-3">{stat.title}</h4>
                <p className="text-muted-foreground">{stat.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Testimonial Section */}
        <div className="bg-muted/50 rounded-2xl p-8 md:p-12 text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-6">
            What Parents Are Saying
          </h3>
          <blockquote className="text-xl italic text-muted-foreground mb-6 max-w-4xl mx-auto">
            "Bobo & Teedee® has become a staple in our household. My children not only love the 
            characters but are learning about different cultures in such a fun and engaging way. 
            It's educational entertainment at its finest."
          </blockquote>
          <cite className="text-primary font-semibold">- Sarah M., Parent from Canada</cite>
        </div>

        {/* Mission Statement */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-6">
            Our Mission: Education Through Entertainment
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="text-left">
              <h4 className="text-xl font-semibold mb-3 text-primary">Cultural Preservation</h4>
              <p className="text-muted-foreground">
                We're committed to preserving and sharing the rich cultural heritage of the 
                Cayman Islands through authentic storytelling and character development.
              </p>
            </div>
            <div className="text-left">
              <h4 className="text-xl font-semibold mb-3 text-secondary">Global Education</h4>
              <p className="text-muted-foreground">
                Our content promotes cross-cultural understanding, environmental awareness, 
                and positive values that resonate with families worldwide.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};